import { RECEIVE_GOAL_DATA, CHANGE_GOAL_INDEX, CLEAR_DATA } from './GoalCarouselActions';
import ClientEmptyState from './GoalCarouselClientEmptyState';
import { ON_MOBILE_LAYOUT_CHANGED } from '../ConsumerArea/ConsumerAreaActions';

const initialState = {};

const GoalCarouseReducer = (state = initialState, action) => {
  switch (action.type) {
    case ON_MOBILE_LAYOUT_CHANGED: {
      return {
        ...initialState,
      };
    }
    case RECEIVE_GOAL_DATA: {
      return {
        ...state,
        [action.clientId]: {
          ...ClientEmptyState,
          goalsList: action.goalsList,
          initialGoalData: action.initialGoalData,
          initialFpId: action.initialFpId,
          currentGoalIndex: action.initialGoalIndex,
        },
      };
    }
    case CHANGE_GOAL_INDEX:
      return {
        ...state,
        [action.clientId]: {
          ...state[action.clientId],
          currentGoalIndex: action.index,
        },
      };
    case CLEAR_DATA:
      return {};
    case 'OVERVIEW.UNSET':
      return {
        ...state,
        [action.clientId]: ClientEmptyState,
      };
    default:
      return state;
  }
};

export default GoalCarouseReducer;
